import cx from 'classnames'
import React, { Component } from 'react'
import ReactDOM from 'react-dom'

import { get } from '@js/common/api'

import CTA from '@f/elements/CTA'
import FormText from '@f/elements/FormText/FormText'
import FormWrapper from '@f/elements/FormWrapper'
import Icon from '@f/elements/Icon'

import ResultsPage from '@f-fertighaus/templates/FullTextSearch/ResultsPage'

const isFertighaus =
  typeof window !== 'undefined' && window.__DOMAIN__ === 'fertighaus'

// Results shown on Toolbar dropdown
const SearchNavResultCategory = ({ suggestions }) => {
  return (
    <div className='f-g-c24 f-g-c6:m'>
      <div className='[ f-p-b-010 f-p-a-0:m f-c-fo-pri ]'>
        <div className='[ f-p-b-010 f-t-tbody ]'>{suggestions.type}</div>
        <ul className='[ f-!list ]'>
          {suggestions.results.map((result, index) => {
            if (index < 4) {
              let category

              switch (result.category) {
                case 'article':
                  category = 'Artikel'
                  break
                case 'category':
                  category = 'Kategorie'
                  break
                case 'landing-page':
                  category = 'Informationen'
                  break
                default:
                  category = result.category
              }
              return (
                <li key={`${result.id}`} className='[ f-m-v-010 ]'>
                  <a
                    className='[ f-t-ellip f-d-inbl f-t-mini f-c-fo-pri ] SiteSearchNav-result-anchor'
                    href={result.link}>
                    {result.text}
                  </a>
                  <span className='[ f-d-bl f-t-micro f-c-fo-neu200 f-t-ellip ]'>
                    {category}
                  </span>
                </li>
              )
            }
          })}
        </ul>
      </div>
    </div>
  )
}

// Get images shown on Full Results Page
const getResultImage = (type, imageSrc, pageLink, track) => {
  switch (type) {
    case 'house':
      return (
        <div className='[ f-m-r-020 ] FullTextSearch-result-image-container'>
          <a
            className='FullTextSearch-result-link'
            onClick={track}
            href={pageLink}>
            <img
              className='FullTextSearch-result-image'
              src={imageSrc}
              loading='lazy'
            />
          </a>
        </div>
      )
    case 'vendor':
      return (
        <div className='[ f-m-r-020 f-c-bo-neu025 ] FullTextSearch-result-image-container FullTextSearch-vendor-image'>
          <a
            className='FullTextSearch-result-link'
            onClick={track}
            href={pageLink}>
            <img
              className='FullTextSearch-result-image'
              src={imageSrc}
              loading='lazy'
            />
          </a>
        </div>
      )
    case 'dictionary':
      return (
        <div className='[ f-m-r-020 f-c-bo-pri f-c-ba-bac025 ] FullTextSearch-result-image-container FullTextSearch-icon-container'>
          <a
            className='FullTextSearch-result-image'
            onClick={track}
            href={pageLink}>
            <Icon
              icon='book-64px'
              className='FullTextSearch-icon [ f-icon-040 f-c-st-pri ]'
            />
          </a>
        </div>
      )
    default:
      return (
        <div className='[ f-m-r-020 ] FullTextSearch-result-image-container'>
          <a
            className='FullTextSearch-result-link'
            onClick={track}
            href={pageLink}>
            <img
              className='FullTextSearch-result-image'
              src={imageSrc}
              loading='lazy'
            />
          </a>
        </div>
      )
  }
}

// Generate Tab Panel
const resultsPageCategory = results => {
  return (
    <div className='[ f-wrap f-p-t-040 f-p-b-020 ]'>
      {results.results.map(result => {
        let type = ''
        if (results.type === 'Alle') {
          type = result.fullType
        } else if (results.type === 'Häuser') {
          type = result.category
        } else if (results.type === 'Ratgeber & Informationen') {
          type = result.subType
        }
        const trackResultClick = () => {
          if (result.type === 'house' || result.type === 'vendor') {
            _wt({
              category: 'item',
              action: 'click',
              label:
                result.type === 'house'
                  ? 'searchresult-house'
                  : 'searchresult-vendor',
              location:
                result.type === 'house'
                  ? 'sitesearch-house'
                  : 'sitesearch-vendor',
              values: [{ type: `${result.type}_nid`, value: result.nid }]
            })
          }
        }
        return (
          <div key={result.id} className='[ f-d-flr f-m-b-040 ]'>
            {getResultImage(
              result.type,
              result.image,
              result.link,
              trackResultClick
            )}
            <div>
              <a
                onClick={trackResultClick}
                href={result.link}
                className='FullTextSearch-result-title [ f-t-tminor f-c-fo-pri ]'>
                {result.text}
              </a>
              {type.length ? (
                <div className='[ f-t-body f-c-fo-pri ]'>{type}</div>
              ) : (
                <span />
              )}
              <div className='[ f-t-body f-c-fo-pri ]'>
                {result.teaser.split(' ').splice(0, 14).join(' ')}
              </div>
              <CTA
                tag='a'
                className='[ f-t-body f-c-fo-pri f-t-centre f-m-b-010 ]'
                type='text-primary'
                onClick={trackResultClick}
                href={result.link}>
                Mehr lesen &gt;
              </CTA>
            </div>
          </div>
        )
      })}
    </div>
  )
}

export default class SiteSearchNav extends Component {
  state = {
    apiSuccess: false,
    suggestions: [],
    search: '',
    country: window.location.hostname.split('.').pop() === 'at' ? 'at' : 'de',
    isMobile: window.innerWidth <= 767
  }

  componentDidMount = () => {
    if (this.props.resultsPage) {
      const querySearch = decodeURIComponent(location.search.slice(10))
      if (querySearch.length) {
        this.getSuggestions(querySearch)
      }
    }
    window.addEventListener('resize', this.handleResize)
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize)
  }

  handleResize = () => {
    this.setState({ isMobile: window.innerWidth <= 767 })
  }

  handleButtonToggle = () => {
    if (this.props.currentActiveMenu === 'search') {
      this.setState({ apiSuccess: false, suggestions: [], search: '' })
      this.props.handleMenuItemClick('')
    } else {
      this.props.handleMenuItemClick('search', true)
    }
  }

  handleInputChange = event => {
    this.getSuggestions(event.target.value)
  }

  handleInputFocus = () => {
    const input = document.querySelector('.FormText')
    input?.focus()
  }

  handleFormSubmit = ({ elements }) => {
    const searchTerm = elements
      .find(element => element.name === 'keywords')
      .value?.replaceAll('+', ' ')

    if (searchTerm) {
      if (this.props.resultsPage) {
        this.getSuggestions(searchTerm)
      } else {
        window.location = `/suche/?keywords=${searchTerm}`
      }
    }
  }

  getSuggestions = querySearch => {
    let searchParams = encodeURIComponent(querySearch)
    if (querySearch.length > 2) {
      get(`suggest/?q=${searchParams}`)
        .then(data => {
          if (data.success) {
            const houseNids = data.results
              .filter(result => result.type === 'house')
              .map(house => house.nid)

            if (houseNids.length > 0)
              _wt({
                category: 'item-collection',
                action: 'display',
                label: 'sitesearch-house',
                values: data.results
                  .filter(result => result.type === 'house')
                  .map(house => ({ type: 'house_nid', value: house.nid }))
              })

            const vendorNids = data.results
              .filter(result => result.type === 'vendor')
              .map(vendor => vendor.nid)

            if (vendorNids.length > 0)
              _wt({
                category: 'item-collection',
                action: 'display',
                label: 'sitesearch-vendor',
                values: data.results
                  .filter(result => result.type === 'vendor')
                  .map(vendor => ({
                    type: 'vendor_nid',
                    value: vendor.nid
                  }))
              })

            this.setState({
              apiSuccess: data.success,
              suggestions: data.results,
              search: querySearch
            })
          }
        })
        .catch(() => {
          this.setState({
            apiSuccess: false,
            search: querySearch
          })
        })
    } else {
      this.setState({
        apiSuccess: false,
        suggestions: [],
        search: querySearch
      })
    }
  }

  render() {
    const { suggestions, apiSuccess, search, country } = this.state
    const { resultsPage } = this.props

    // Sort suggestions into Categories
    let allCategories = { results: [], type: 'Alle' }
    let houseSuggestions = { results: [], type: 'Häuser' }
    let vendorSuggestions = { results: [], type: 'Anbieter' }
    let dictionarySuggestions = { results: [], type: 'Lexikon' }
    let guidebookSuggestions = { results: [], type: 'Ratgeber & Informationen' }

    suggestions.map(suggestion => {
      switch (suggestion.type) {
        case 'house':
          suggestion[
            'fullType'
          ] = `${houseSuggestions.type} | ${suggestion.category}`
          houseSuggestions.results.push(suggestion)
          allCategories.results.push(suggestion)
          break
        case 'vendor':
          suggestion['fullType'] = `${vendorSuggestions.type}`
          vendorSuggestions.results.push(suggestion)
          allCategories.results.push(suggestion)
          break
        case 'dictionary':
          suggestion['fullType'] = `${dictionarySuggestions.type}`
          dictionarySuggestions.results.push(suggestion)
          allCategories.results.push(suggestion)
          break
        case 'guidebook':
          suggestion['fullType'] = ''
          if (suggestion.category === 'article') {
            suggestion['subType'] = 'ARTIKEL'
            suggestion[
              'fullType'
            ] = `${guidebookSuggestions.type} | ${suggestion.subType}`
          } else if (suggestion.category === 'category') {
            suggestion['subType'] = 'KATEGORIE'
            suggestion[
              'fullType'
            ] = `${guidebookSuggestions.type} | ${suggestion.subType}`
          } else {
            suggestion['subType'] = 'INFORMATIONEN'
            suggestion[
              'fullType'
            ] = `${guidebookSuggestions.type} | ${suggestion.subType}`
          }
          guidebookSuggestions.results.push(suggestion)
          allCategories.results.push(suggestion)
          break
      }
    })

    let categoryResults = [
      houseSuggestions,
      vendorSuggestions,
      dictionarySuggestions,
      guidebookSuggestions
    ]

    const showIntermediateResults =
      suggestions.length > 0 && apiSuccess && !resultsPage

    // Generate Tab Content
    let tabNames = []
    let tabPanels = []

    // Tab Content
    if (resultsPage) {
      tabNames.push({
        text: `Alle (${allCategories.results.length})`,
        selenium: 'btg-ctg-all'
      })
      tabPanels.push(resultsPageCategory(allCategories, search, country))
      if (houseSuggestions.results.length) {
        tabNames.push({
          text: `Häuser (${houseSuggestions.results.length})`,
          selenium: 'btn-ctg-hs'
        })
        tabPanels.push(resultsPageCategory(houseSuggestions, search, country))
      }
      if (vendorSuggestions.results.length) {
        tabNames.push({
          text: `Anbieter (${vendorSuggestions.results.length})`,
          selenium: 'btn-ctg-vd'
        })
        tabPanels.push(resultsPageCategory(vendorSuggestions, search, country))
      }
      if (dictionarySuggestions.results.length) {
        tabNames.push({
          text: `Lexikon (${dictionarySuggestions.results.length})`,
          selenium: 'btn-ctg-lx'
        })
        tabPanels.push(
          resultsPageCategory(dictionarySuggestions, search, country)
        )
      }
      if (guidebookSuggestions.results.length) {
        tabNames.push({
          text: `Ratgeber & Informationen (${guidebookSuggestions.results.length})`,
          selenium: 'btn-ctg-gb'
        })
        tabPanels.push(
          resultsPageCategory(guidebookSuggestions, search, country)
        )
      }
    }

    // Keep this in new file popularResults.js?
    const popularResults = {
      results: [
        {
          category: 'Hanse Haus',
          fullType: 'HÄUSER | Hanse Haus',
          id: 'fertighaus.house.4062',
          image:
            'https://cdn.fertighaus.de/images/hanse-bungalow122_exterior1.fill-320x240.jpg?t=743f1b76',
          link: '/haeuser/hanse-bungalow122/',
          text: 'Bungalow 116',
          teaser:
            'Der Bungalow 122 zeigt eindrucksvoll, wie modern und spannend der Bungalow-Stil interpretiert werden kann. ',
          type: 'house'
        },
        {
          category: 'Town & Country Haus',
          fullType: 'HÄUSER | Town & Country Haus',
          id: 'fertighaus.house.2026',
          image:
            'https://cdn.fertighaus.de/images/tc_winkelbungalow108_exterior3.fill-320x240.jpg?t=759739b0',
          link: '/haeuser/winkelbungalow-108/',
          text: 'Winkelbungalow 108',
          teaser:
            'Dieser Bungalow fällt nicht nur durch sein charmantes Design auf. Die markante Winkelform ermöglicht auch einen variablen Grundriss. ',
          type: 'house'
        },
        {
          category: 'Heinz von Heiden',
          fullType: 'HÄUSER | Heinz von Heiden',
          id: 'fertighaus.house.5299',
          image:
            'https://cdn.fertighaus.de/images/hvh_unveraenderlicheb54_exterior1.fill-320x240.jpg?t=4a6fc025',
          link: '/haeuser/hvh_unveraenderlichb54/',
          text: 'Der Unverbesserliche B540',
          teaser:
            'Mit einer überdachten Terrasse, die 5 m² Fläche bietet und 99,60 m² Wohnfläche in denen 3 Schlafzimmer untergebracht sind, ist der Unverbesserliche B540 der perfekte Bungalow für Jung und Alt. ',
          type: 'house'
        },
        {
          category: null,
          fullType: 'ANBIETER',
          id: 'fertighaus.vendor.119',
          image:
            'https://cdn.fertighaus.de/images/hvh_logo3.max-400x400.noauto.png?t=f59eebde',
          link: '/anbieter/heinz-von-heiden/',
          text: 'Heinz von Heiden Massivhäuser',
          teaser:
            'Heinz von Heiden ist eines der erfolgreichsten Unternehmen Deutschlands, das sich auf den Bau von massiven Einfamilien-, Doppel- und Reihenhäusern spezialisiert hat. ',
          type: 'vendor'
        },
        {
          category: null,
          id: 'fertighaus.vendor.33',
          fullType: 'ANBIETER',
          image:
            'https://cdn.fertighaus.de/images/towncountry_logo3.original.png?t=23f17150',
          link: '/anbieter/town-country-haus/',
          text: 'Town & Country Haus',
          teaser:
            'Town & Country gehört zu den bekanntesten deutschen Baufirmen. Der Massivhaushersteller setzt auf langjährige Erfahrung durch den Bau verschiedenster Häuser. ',
          type: 'vendor'
        },
        {
          category: null,
          id: 'fertighaus.vendor.147',
          fullType: 'ANBIETER',
          image:
            'https://cdn.fertighaus.de/images/kampa_logo4.max-400x400.noauto.png?t=5b7c4df1',
          link: '/anbieter/kampa/',
          text: 'KAMPA',
          teaser:
            'Der Fertighausanbieter KAMPA baut Häuser für die Zukunft, ganz gleich ob für Alleinstehende, Paare oder Familien, für Menschen, denen die Umwelt am Herzen liegt, die Wert auf Design legen und darüber hinaus auf ihre Gesundheit achten. ',
          type: 'vendor'
        },
        {
          category: 'article',
          id: 3755,
          fullType: 'RATGEBER & INFORMATIONEN | ARTIKEL',
          image:
            'https://cdn.fertighaus.de/images/bild_neu.fill-312x223.png?t=42374f2a',
          link:
            '/ratgeber/hausbau/was-kostet-ein-haus-ausfuehrliche-antworten/',
          text:
            'Was kostet ein Haus? Ausführliche Antworten zur Kostenzusammenstellung',
          teaser:
            'Jeder Bauherr oder jeder Käufer einer Immobilie stellt sich vor Realisierung seines Vorhabens die Frage: was kostet das Haus? Der Hausbau umfasst eine Vielzahl an Einzelleistungen, die sich in entsprechenden Kostenpositionen niederschlagen. ',
          type: 'guidebook'
        },
        {
          category: 'article',
          id: 3856,
          fullType: 'RATGEBER & INFORMATIONEN | ARTIKEL',
          image:
            'http://cdn.fertighaus.de/images/Nachhaltigkeit-im-Fokus-unsplash.fill-312x223.jpg?t=6ee33678',
          link:
            '/ratgeber/energiesparen-nachhaltigkeit/geld-sparen-durch-foerderungen-fuer-ein-energieeffizientes-haus/',
          text: 'Geld sparen durch Förderungen für ein energieeffizientes Haus',
          teaser:
            'Wer seinen Traum von den eigenen vier Wänden verwirklicht, möchte heute energieeffizient bauen - nicht nur der Umwelt zuliebe, sondern um später Energie und Kosten zu sparen. Energieeffizientes Bauen wird sogar gefördert - mit zinsgünstigen Krediten und attraktiven Zuschüssen. Mehr dazu erfahren Sie hier.',
          type: 'guidebook'
        },
        {
          category: 'article',
          id: 3614,
          fullType: 'RATGEBER & INFORMATIONEN | ARTIKEL',
          image:
            'http://cdn.fertighaus.de/images/Fotolia_76124302_Subscription_Monthly_M.fill-312x223.jpg?t=2e1edf0f',
          link:
            '/ratgeber/hausbau/bodenplatte-beim-fertighaus-welche-techniken-gibt-es-und-was-kosten-diese/',
          text: 'Bodenplatte - Welche Techniken gibt es und was kosten diese?',
          teaser:
            'Beim Bau eines jeden Hauses muss eine entsprechende Gründung vorhanden sein. Nicht jedes Haus benötigt jedoch unbedingt eine klassische Bodenplatte. Die Lastenverteilung kann auch ein Streifenfundament, eine Pfahlgründung oder ein Plattenfundament übernehmen. ',
          type: 'guidebook'
        }
      ],
      type: 'Alle'
    }

    const tabContent = {
      tabNames,
      tabPanels
    }

    const fullResultsMount = document.querySelector('.js-full-results')

    return (
      <div className='[ f-d-inbl ] PageHeader-menu-wrapper'>
        {isFertighaus && (
          <CTA
            type='icon'
            className={`[ f-p-a-010 f-m-v-010 ] PageHeader-button PageHeader-with-submenu ${
              this.props.currentActiveMenu === 'search' || resultsPage
                ? 'is-open'
                : ''
            }`}
            onClick={
              resultsPage ? this.handleInputFocus : this.handleButtonToggle
            }
            data-sel='btn-srch-ic'
            wtData={{
              'CTA-click': {
                label:
                  this.props.currentActiveMenu === 'search'
                    ? 'search-close'
                    : 'search-start',
                location: 'header'
              }
            }}>
            <Icon
              icon={
                this.props.currentActiveMenu === 'search' && this.state.isMobile
                  ? 'close-16px'
                  : 'search-16px'
              }
              className={`[ f-icon-030 f-c-st-whi ] ${
                resultsPage ? 'is-open' : ''
              } PageHeader-button-icon`}
            />
            <span className='[ f-hidden:s f-hidden:m f-c-st-inherit ] PageHeader-button-label'>
              Suchen
            </span>
          </CTA>
        )}
        {this.props.currentActiveMenu === 'search' || resultsPage ? (
          <div
            className={`PageHeader-menu-fullwidth SiteSearchNav-toolbar ${
              resultsPage ? 'SiteSearchNav-full' : ''
            }`}>
            <div
              className={`[ f-c-ba-whi f-p-v-020 ] PageHeader-menu-fullwidth-content ${
                resultsPage ? 'SiteSearchNav-input-shadow' : ''
              }`}>
              <FormWrapper
                className='[ f-wrap f-d-flr ]'
                action='/suche/'
                onSuccess={this.handleFormSubmit}
                wtData={{
                  form: {
                    label: 'search',
                    location: 'header'
                  }
                }}
                data-wtloc='header'
                data-wtlab='search'>
                <FormText
                  formElement
                  inputField
                  name='keywords'
                  autoComplete='off'
                  className={cx(
                    '[ f-t-input f-c-bo-neu025 ] SiteSearchNav-form-input is-full-width js-search-input',
                    resultsPage ? 'f-m-r-010' : 'f-m-r-010:m'
                  )}
                  data-sel='ipt-srch'
                  maxLength={128}
                  placeholder='Häuser, Anbieter...'
                  defaultValue={
                    resultsPage
                      ? decodeURIComponent(location.search.slice(10))
                      : ''
                  }
                  onChange={this.handleInputChange}
                  autoFocus
                />
                {!(
                  this.state.isMobile &&
                  !resultsPage &&
                  search.length < 3
                ) && (
                  <div
                    className={cx(
                      !resultsPage && 'SiteSearchNav-search-button-wrapper'
                    )}>
                    <CTA
                      type='block-primary'
                      tag='button'
                      buttonType='submit'
                      data-sel='btn-srch-cf'
                      className={`${search.length > 2 ? '' : 'is-disabled'}`}
                      wtData={{
                        'CTA-click': {
                          label: 'search-submit',
                          location: 'header'
                        }
                      }}>
                      Suche
                    </CTA>
                  </div>
                )}
              </FormWrapper>
              {showIntermediateResults && (
                <div className='[ f-wrap f-c-ba-whi f-p-t-020 ] SiteSearchNav-suggestions-container'>
                  <div className='[ f-g-r ]'>
                    {categoryResults.map(
                      (category, index) =>
                        category.results.length > 0 && (
                          <SearchNavResultCategory
                            suggestions={category}
                            search={search}
                            country={country}
                            key={`${category}-${index}`}
                          />
                        )
                    )}
                  </div>
                </div>
              )}
            </div>
          </div>
        ) : null}
        {resultsPage &&
          fullResultsMount &&
          ReactDOM.createPortal(
            <ResultsPage
              apiSuccess={apiSuccess}
              allCategories={allCategories}
              search={search}
              resultsPageCategory={resultsPageCategory}
              country={country}
              tabContent={tabContent}
              popularResults={popularResults}
            />,
            fullResultsMount
          )}
      </div>
    )
  }
}
